/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Navigation_RightInputs */

const en_directory_comparison_product_hunt_rows_navigation_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Navigation_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse launches, collections, and rankings`)
};

const zh_directory_comparison_product_hunt_rows_navigation_right = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Navigation_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览发布、合集与排行`)
};

/**
* | output |
* | --- |
* | "Browse launches, collections, and rankings" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Navigation_RightInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_navigation_right = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Navigation_RightInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Navigation_RightInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_navigation_right(inputs)
	return zh_directory_comparison_product_hunt_rows_navigation_right(inputs)
});
export { directory_comparison_product_hunt_rows_navigation_right as "directory.comparison.product_hunt.rows.navigation.right" }